let lastIndex = 0;

export function makeComponentID(): string {
    lastIndex++;
    return `c${lastIndex}`;
}
